import { ReactElement } from 'react';
import replaceUmlaute from 'utils/replaceUmlaute';

interface Row {
  row: string | JSX.Element[];
}

interface TableData {
  head: {
    title: any;
    width: number;
    sortMethod: string;
    sortDirection?: string;
  }[];
  body: {
    rows: Row[];
  };
}

const getSortableValue = (value: string | ReactElement) => {
  // match if only digits and optional apostrophe
  if (typeof value === 'string' && value.match(/^\d+'?\d*$/)) {
    return parseInt(value.replace("'", ''), 10);
  }
  if (typeof value === 'object') {
    return value.props.children as string;
  }
  return value;
};

const useGetTableSortFunction =
  (data: TableData, updateData: (data: TableData) => void) => (sortIndex: number) => {
    updateData({
      ...data,
      head: data.head.map(({ sortDirection, ...header }, index: number) => {
        let newSortDirection: string = null;
        if (sortIndex === index) {
          newSortDirection = sortDirection && sortDirection === 'asc' ? 'desc' : 'asc';
        }
        return {
          sortDirection: newSortDirection,
          ...header,
        };
      }),
      body: {
        rows: data.body.rows.sort((a: Row, b: Row) => {
          const { sortDirection } = data.head[sortIndex];
          const aValue = getSortableValue(a[sortIndex]);
          const bValue = getSortableValue(b[sortIndex]);
          if (sortDirection === 'asc') {
            if (typeof aValue === 'number' && typeof bValue === 'number') {
              return aValue - bValue > 0 ? -1 : 1;
            }
            if (typeof aValue === 'string' && typeof bValue === 'string') {
              return replaceUmlaute(bValue).localeCompare(replaceUmlaute(aValue));
            }
          }
          if (typeof aValue === 'number' && typeof bValue === 'number') {
            return bValue - aValue > 0 ? -1 : 1;
          }
          if (typeof aValue === 'string' && typeof bValue === 'string') {
            return replaceUmlaute(aValue).localeCompare(replaceUmlaute(bValue));
          }
          return 0;
        }),
      },
    });
  };

export default useGetTableSortFunction;
